import styled from 'styled-components';

export const StyledList = styled.ul`
  margin: 0;
  margin-top: 20px;
  padding: 0;
  list-style-type: none;
`;

export const StyledItem = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 32px;

  &:not(:first-of-type) {
    margin-top: 10px;
  }
`;
